import React from 'react';
import { Icon } from '../../../../../../../../../ui-kit';
import { SelectedColorBlock, ArrowBlock, OptionsListElement, RelativeBlock } from '../../../Blocks/components/common/StyledEditables';


const FillColor = ({ active, style }) =>
<RelativeBlock>
    <OptionsListElement>
      <span>
        <Icon name="fill" color="white" size={18} />
        <SelectedColorBlock style={{ background: style.background || style.backgroundColor || '#1A1F24' }} />
      </span>
      <ArrowBlock
      active={active}
      name="arrowdown"
      color="white"
      size={12} />

    </OptionsListElement>
  </RelativeBlock>;


export default FillColor;